export default __webpack_public_path__ + "static/media/resume-canvas.6f3225a0.png";